import type { ApiFlowsExecutionsResponseType } from "@/types/entities/flows";
import { formatDateTime } from "@/utils/dates";
import { Operations } from "@/workflow/components/configurations/if/operations";
import type { Conditions } from "@/workflow_api/types/workflow";
import { getExecutionBadge } from ".";
import { Icon } from "@elaniintc/goes-design-system";

interface Props {
  execution: ApiFlowsExecutionsResponseType["data"][number]["node_executions"][number];
}

const IfSimpleContent = ({ execution }: Props) => {
  if (!execution || !execution.inputs || !execution.outputs) {
    return (
      <div className="p-4 border border-error-quiet rounded-lg bg-error-silent flex gap-3 items-start">
        <Icon
          type="fas"
          name="exclamation-triangle"
          className="text-error py-2.5"
          size="sm"
          aria-label="Error"
        />
        <div>
          <p className="font-semibold text-error-loud">
            No se pudo cargar la información
          </p>
          <p className="text-sm text-error mt-1">
            No hay datos de ejecución disponibles para este nodo.
          </p>
        </div>
      </div>
    );
  }

  const result = execution.outputs[0]?.value as boolean;
  const condition = execution.inputs[0].conditions!;
  return (
    <div className="border border-neutral rounded-lg p-4 bg-neutral-object flex flex-col gap-1">
      <p>Estado del nodo: {getExecutionBadge(execution.status)}</p>
      <p>Se completó el: {formatDateTime(execution.ended_at || "")}</p>
      <OperationsFormatter conditions={condition} />
      <p>
        El resultado de la condición fue:{" "}
        <span className="font-semibold">{result ? "Verdadero" : "Falso"}</span>
      </p>
    </div>
  );
};
const logicalOperator = (operator: string) => {
  const op = operator;
  if (op === "AND") return "Y";
  if (op === "OR") return "O";
  if (op === "NOT") return "Y NO";
  return op;
};

const OperationsFormatter = ({ conditions }: { conditions: Conditions }) => {
  const firstCondition = conditions[0];

  const getOperation = (condition: Conditions[number]) => {
    const operationType = condition.input?.type?.toLowerCase() || "";
    const operations = Operations[operationType];
    if (!operations) return null;

    const operation = operations.find((op) => {
      return op.name === firstCondition.type;
    });
    if (!operation) return null;
    return operation;
  };

  return (
    <div>
      <p>Operación realizada: </p>
      <p className="pl-4">
        <span>{JSON.stringify(firstCondition.input?.value as string)}</span>{" "}
        {getOperation(firstCondition)?.label || firstCondition.type}{" "}
        {firstCondition?.optional_input && (
          <span>
            {JSON.stringify(firstCondition?.optional_input.value as string)}
          </span>
        )}{" "}
        {conditions.length > 1 && (
          <span> {logicalOperator(firstCondition.operator || "")} </span>
        )}
      </p>
      {conditions.slice(1).map((condition, index) => {
        const operation = getOperation(condition);
        console.log(operation, condition);
        return (
          <p className="pl-4" key={index}>
            <span>{JSON.stringify(condition.input?.value as string)}</span>{" "}
            {operation?.label || condition.type}{" "}
            {condition?.optional_input && (
              <span>
                {JSON.stringify(condition?.optional_input.value as string)}
              </span>
            )}{" "}
            {index < conditions.length - 2 && (
              <span> {logicalOperator(condition.operator || "")} </span>
            )}
          </p>
        );
      })}
    </div>
  );
};

export default IfSimpleContent;
